module.exports = __webpack_public_path__ + "media/images/kebab_menu-816725c2a2be60e7719561752683c537.svg";